// @flow

import { connect } from "react-redux";
import PhotoCard from "./view";
import { nextPhoto, previousPhoto } from "../../state/blogs/actions";

export default connect(
    () => ({}),
    dispatch => ({
        onNext: () => dispatch(nextPhoto()),
        onBack: () => dispatch(previousPhoto())
    })
)(PhotoCard);



// WEBPACK FOOTER //
// ./src/photo-dialog/photo-card/index.js